module.exports = __webpack_public_path__ + "frontend/images/gold/ultimate/bg.jpg?a781e1b28258dd291049d167aeead8f8";